import { UseFormReturn } from "react-hook-form";
import { ProductFormData } from "../../types/product";
import { useTranslation } from "../../core/translation.core";
import { useQuery } from "@tanstack/react-query";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { selectCss } from "../reuseables/native.comp";
import localeCore from "../../core/locale.core";
import recycleCore from "../../core/recycle.core";
import useShop from "../../hooks/useShop.hook";

interface RecycleProductSelectorProps {
  methods: UseFormReturn<ProductFormData, any>;
}
export default function RecycleProductSelector({ methods }: RecycleProductSelectorProps) {
  const { t, msg } = useTranslation();
  const { selectedShop } = useShop();

  const {
    data: recycleProducts,
    isLoading,
    error,
    isError,
  } = useQuery({
    queryKey: ["recycleProducts"],
    queryFn: () => recycleCore.listRecycleProducts(""),
    enabled: selectedShop?.recycleEnabled,
  });

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;
  if (!selectedShop?.recycleEnabled) return null;

  return (
    <div id="recycle-products-list">
      <div className="">
        <h2>{t(msg.product.attachRecycle)}</h2>
        <select className={`${selectCss} w-full max-w-64 text-xs h-[40px]`} {...methods.register("recycleInventoryProduct")}>
          <option></option>
          {recycleProducts!.map((p) => (
            <option key={p.id} value={p.id}>
              {localeCore.getLocaleValueDefaultFallback(p.name)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
